import type { MouseEventHandler } from 'react';

import { usePayerConnectionsLive } from '../store/usePayerConnectionsLive';

import { AdminPayerConnectionsView } from './AdminPayerConnectionsView';

export function AdminPayerConnections({
  organizationId,
  onReviewIntakeClick,
  intakeReviewPath,
}: {
  organizationId: string;
  onReviewIntakeClick?: MouseEventHandler<HTMLAnchorElement>;
  intakeReviewPath?: string;
}) {
  const { rows, refetch, ...data } = usePayerConnectionsLive(organizationId);
  return (
    <AdminPayerConnectionsView
      {...data}
      rowCount={rows.length}
      onRetry={refetch}
      intakeReviewPath={
        intakeReviewPath ??
        `/admin-v2/organization/${encodeURIComponent(organizationId)}?tab=intake-hub`
      }
      onReviewIntakeClick={onReviewIntakeClick}
    />
  );
}
